import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { RepoFile } from "types/generated";

import { parseFilePath } from "../../../helpers";
import useFilesNavigation from "../../Table/useFilesNavigation";

const PathCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  const { setCurrentPath } = useFilesNavigation();
  const { folder: nestedFolder, segments } = parseFilePath(item.filePath);

  const handleNavigateToFolder = () => {
    setCurrentPath(segments);
  };

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink onPress={handleNavigateToFolder}>{nestedFolder || "root"}</TableCellLink>
    </TableSimpleCell>
  );
};

export default PathCell;
